import { Close } from "mdi-material-ui";
import {
    Box, Dialog, DialogContent, DialogTitle, IconButton, DialogActions, Button
} from "@mui/material";

interface WrapperProps {
  maxWidth?: "xs" | "sm" | "md" | "lg" | "lg";
  children: JSX.Element;
  header?: JSX.Element;
  title: string;
  onDialogClose?: (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => void;
  onClose?: () => void;
  isOpen: boolean;
  footer?: boolean | JSX.Element;
  fullScreen?: boolean;
}

export default function DialogWrapper({
  children,
  title,
  onClose,
  onDialogClose,
  isOpen,
  footer,
  fullScreen = false,
  maxWidth="sm"
}: WrapperProps) {
  return (
    <Dialog open={isOpen} onClose={onDialogClose} fullScreen={fullScreen} fullWidth={true} maxWidth={maxWidth} keepMounted={false}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <DialogTitle><strong>{title}</strong></DialogTitle>
        <IconButton onClick={onClose} style={{marginRight:"5px"}}>
          <Close fontSize="inherit" />
        </IconButton>
      </Box>
      <DialogContent>{children}</DialogContent>
      {
        footer && (
          typeof footer == "boolean" ? (
            <DialogActions>
              <Button variant="outlined" color="primary" size="small" onClick={onClose}>
                Close
              </Button>
            </DialogActions>
          ) : footer
        )
      }
    </Dialog>
  );
}